import { render, staticRenderFns } from "./Accumulation.vue?vue&type=template&id=56706a0d&scoped=true"
import script from "./Accumulation.vue?vue&type=script&lang=js"
export * from "./Accumulation.vue?vue&type=script&lang=js"
import style0 from "./Accumulation.vue?vue&type=style&index=0&id=56706a0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56706a0d",
  null
  
)

export default component.exports